import React, { createContext, useContext, type PropsWithChildren } from 'react';
import type { ConfigState, useFetchSettingsReturnType } from '../common/types.tsx';
import type { ExtendedDialogData } from './useFetchExtendedDialogData.tsx';

export type Props = {
	config: ConfigState;
	emailSettings: useFetchSettingsReturnType['result'];
	formSettings: {
		isBrowseUsersDisabled?: boolean;
		extendedDialogData: ExtendedDialogData;
	};
};

const initialProps: Props = {
	config: 'fetching',
	emailSettings: {
		status: 'loading',
		payload: undefined,
	},
	formSettings: {
		extendedDialogData: 'idle',
	},
};

export const EntrypointPropsContext = createContext<Props>(initialProps);

export const EntrypointPropsProvider = ({
	config,
	children,
	emailSettings,
	formSettings,
}: PropsWithChildren<Props>) => {
	return (
		<EntrypointPropsContext.Provider
			value={{
				config,
				emailSettings,
				formSettings,
			}}
		>
			{children}
		</EntrypointPropsContext.Provider>
	);
};

export const useEntrypointProps = () => useContext(EntrypointPropsContext);
